/**
 * ****************************************************************************
 * @description     :   Main layout for app, have common header and footer for all page
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

/**
 * import for redux
 */
import Actions from "../redux/app/actions";

/**
 * import chid components
 */
import LeftMenu from "./left-menu";
import MainHeader from "./main-header";
import SidebarMobile from "./sidebar-mobile";

/**
 * import chid components with lazyload
 */
const Dashboard = React.lazy(() => import("../pages/dashboard"));
// const DailyReport = React.lazy(() => import("../pages/chat"));
const NotFound = React.lazy(() => import("../pages/404"));

/**
 * Main layout for app, have common header and footer for all page
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const Layout = () => {
    const dispatch = useDispatch();

    /**
     * Get data common for layout
     */
    useEffect(() => {
        dispatch(Actions.GetMenus());
        dispatch(Actions.GetChats());
        dispatch(Actions.GetSidebarMobile());
        dispatch(Actions.GetNotify());
    }, []);

    const {
        menus,
        currentMenu,
        showLeftHeader,
        dataTitle,
        chats,
        notify,
        openningMenuMobile,
        sidebarMenus
    } = useSelector(
        (state) => state.app
    );

    return (
        <div id="app" className="nk-app-root">
            <LeftMenu menus={menus} currentMenu={currentMenu} />
            <div className="nk-main">
                <div className="nk-wrap">
                    <MainHeader
                        showLeftHeader={showLeftHeader}
                        dataTitle={dataTitle}
                        chats={chats}
                        notify={notify}
                    />
                    <SidebarMobile openningMenuMobile={openningMenuMobile} sidebarMenus={sidebarMenus} />
                    <Suspense
                        fallback={(
                            <>
                                <div className="loading-bg" />
                                <img
                                    className="loading-img"
                                    src="/images/loading.gif"
                                    alt="loading"
                                />
                            </>
                        )}
                    >
                        <Routes>
                            <Route path="/" exact element={<Dashboard />} />
                            <Route path="dashboard" exact element={<Dashboard />} />
                            <Route path="daily-report-system" exact element={<Dashboard />} />
                            <Route element={<NotFound />} />
                        </Routes>
                    </Suspense>
                </div>
            </div>
        </div>
    );
};

export default React.memo(Layout);
